<div class="d-flex flex-column align-items-center align-items-sm-start mt-3">
  <ul class="nav flex-column nav-pills w-100">

    <li class="nav-item">
      <a class="nav-link" routerLink="admin/users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <i class="fs-4 bi-people align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">Users</span>
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLink="/file-explorer" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <i class="fs-4 bi-folder align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">File Explorer</span>
      </a>
    </li>

    <li class="nav-item">
      <button class="nav-link" (click)="toggleTodo()">
        <i class="fs-4 bi-list-task align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">TODO Collapsible</span><i class="ms-2 bi me-1 align-middle" [ngClass]="{'bi-caret-down': showTodoSection, 'bi-caret-up': !showTodoSection}"></i>
      </button>
    </li>
    <li class="ps-4" [ngClass]="{'collapse': !showTodoSection}">
      <ul class="nav flex-column nav-pills w-100">
        <li class="nav-item">
          <a class="nav-link" routerLink="admin/users/testPatch@test.com" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fs-4 bi-1-circle align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">Update testPatch</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fs-4 bi-2-circle align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="admin/users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fs-4 bi-people align-middle"></i> <span class="ms-1 d-none d-sm-inline align-middle">Users duplicate</span>
          </a>
        </li>
      </ul>
    </li>

  </ul>
</div>
